"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { track } from "@lib/track";

// Mounted once in the ROOT layout (app/layout.tsx), so this fires on every public
// route — it moved out of the /workwithme layout on 2026-05-27. It lived in
// app/workwithme/ and reported component "WorkWithMeLayout" long after it stopped
// being either, which is how a shop page_view came to be stamped with the name of a
// layout it never renders under.
export default function PageViewTracker() {
  const pathname = usePathname();

  useEffect(() => {
    const title = typeof document !== "undefined" ? document.title : "";
    track(
      "page_view",
      { label: pathname, component: "RootLayout" },
      {
        event: "page_view",
        label: pathname,
        meta: { title },
      }
    );
  }, [pathname]);

  return null;
}
